const currentDate = new Date();
export const getDayOfYear = () => {
    const startOfYear = new Date(currentDate.getFullYear(), 0, 0);
    const diff = currentDate.getTime() - startOfYear.getTime();
    const oneDay = 1000 * 60 * 60 * 24;
    return Math.floor(diff / oneDay);
};
export const getMonthOfYear = () => {
    return currentDate.getMonth() + 1;
};
export const getYear = () => {
    return currentDate.getFullYear();
};
